import { useHistory } from 'react-router-dom';
import LeftBar from '../components/common/NavBar';
import { GO_TO_APPOINTMENTS } from '../routes/paths';
import { getSelectedClinicId } from '../store/idbHandler';
import { NotFoundSVG } from '../components/common/Icons';

const NotFound: React.FC = () => {
    const history = useHistory();

    const goToDashboard = (): void => {
        history.replace(GO_TO_APPOINTMENTS(getSelectedClinicId() || ''));
    };

    return (
        <div className="w-screen h-screen font-lato bg-neutral-9 select-none">
            <div className="flex w-full h-full min-w-840 overflow-x-auto items-center bg-white">
                <LeftBar />
                <div className="w-full overflow-hidden">
                    <div className="grid grid-cols-12 items-start gap-x-24 items-center">
                        <div className="flex flex-col items-center col-span-4 col-start-5 space-y-48 max-h-504">
                            <div className="flex flex-col items-center space-y-24">
                                <div>
                                    <NotFoundSVG />
                                </div>
                                <div className="flex flex-col items-center space-y-8 flex-nowrap">
                                    <p className="text-status-error font-300 text-69">404 Error</p>
                                    <p className="leading-9 font-600 text-23 text-neutral-2">
                                        Page not found
                                    </p>
                                    <p className="w-full text-center text-neutral-4 text-16">
                                        The page you are requesting may have been moved to a
                                        different location or removed from the server.
                                    </p>
                                </div>
                            </div>
                            <button
                                onClick={goToDashboard}
                                className="inline-flex items-center focus:outline-none text-white bg-actionPrimary text-actionPrimary-inverted rounded-5 hover:bg-actionPrimary-hover active:bg-actionPrimary-active disabled:bg-actionPrimary-disabled disabled:cursor-not-allowed px-16 py-12 btn"
                                type="button"
                            >
                                <span className="pr-8"></span>
                                <span>Goto Dashboard</span>
                                <span className="pl-8"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
